import React, { useCallback, useEffect } from "react"
import styles from "./ImageCarousel.module.scss"
import { useState } from "react"
import Image from "../Image"
import { cn } from "../../lib/helpers"

const ImageCarousel = ({ statement, images }) => {
  const [evenImageIndex, setEvenImageIndex] = useState(0)
  const [oddImageIndex, setOddImageIndex] = useState(0)
  const [isEven, setEven] = useState(false)
  const [isFading, setFading] = useState(false)
  const interval = 5000
  const transitionDuration = 600


  const changeImage = useCallback((even, index) => {
    const getNextImageIndex = (count) => {
      return (
        images.length <= count + 1 ? 0 : count + 1
      )
    }
    !even ? setEvenImageIndex(index) : setOddImageIndex(index)
    setEven(even)
    index = getNextImageIndex(index)
    even = !even
    setFading(false)
    setTimeout(() => {
      setFading(true)
    }, interval - transitionDuration)
    return [even, index]
  }, [images.length])

  const carousel = () => {
    let index = 1
    let even = false
    let carouselInterval
      ;[even, index] = changeImage(even, index)
    carouselInterval = setInterval(() => {
      ;[even, index] = changeImage(even, index)
    }, interval)

    return () => {
      clearInterval(carouselInterval)
    }
  }

  useEffect(carousel, [changeImage])
  return (
    <div className={styles.carouselWrapper}>
      <h1>{statement}</h1>
      <Image
        image={images[evenImageIndex]}
        className={cn(
          styles.mainImage,
          isEven && styles.top,
          isEven && isFading && styles.fade
        )}
      />
      <Image
        image={images[oddImageIndex]}
        className={cn(
          styles.mainImage,
          !isEven && styles.top,
          !isEven && isFading && styles.fade
        )}
      />
    </div>
  )
}

ImageCarousel.propTypes = {}

export default ImageCarousel
